import * as cldrSegmentation from 'cldr-segmentation';

export default function sentenceSplit(sourceLanguage, text) {
  const suppressions = cldrSegmentation.suppressions[sourceLanguage];
  const sentences = cldrSegmentation.sentenceSplit(text, suppressions);
  return sentences
    .map(sentence => sentence.trim())
    .filter(sentence => sentence.length > 0);
}
